<template>
  <div class="new-character">
    <header>
      <div>New Character</div>
      <router-link :to="{name: 'ListCharacters'}">
        Back to list
      </router-link>
    </header>
    <div class="new-character__upload">
      <div v-if="character">
        <character-form
          v-bind="character"
          :disabled="isSaving"
          @submit="save"
        />
      </div>
      <div v-else>
        <upload-character @complete="setCharacter" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CharacterForm from './CharacterForm.vue';
import UploadCharacter from './UploadCharacter.vue';

export default {
  name: 'EditCharacter',
  data() {
    return {
      isSaving: false,
      character: null,
    };
  },
  components: {
    CharacterForm,
    UploadCharacter,
  },
  beforeCreate() {
    this.$store.dispatch('fetch', { model: 'characters' });
  },
  computed: {
    ...mapGetters(['getAllCharacters']),
  },
  methods: {
    ...mapActions(['createCharacter']),
    setCharacter(value) {
      this.character = value;
    },
    save(form) {
      const position = this.getAllCharacters && (this.getAllCharacters.length + 1);
      this.isSaving = true;
      this.createCharacter({
        ...form,
        position,
      }).then(() => {
        this.$router.push({ name: 'ListCharacters' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-character {
  header {
    text-align: center;
    margin-bottom: 30px;
    div {
      font-weight: 500;
    }
    a {
      font-size: var(--font-small);
    }
  }
  &__upload {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 300px);
  }
}
</style>
